import React from 'react';
import Icon from './Icon';
import './Header.css';

/**
 * Header — Editorial layout (SilSurpur / ShakeAndWin ile birebir yapı).
 *
 * Fragment olarak iki blok döndürür (üst kapsayıcı .ck-stage App.js'tedir):
 *   ck-top   → LONG logo · "Hak" sayacı · tag + history ikon butonları
 *   ck-hero  → ck-hero-left (eyebrow + büyük başlık + alt yazı) + ck-hero-right (children = çark)
 *
 * Sağ sütuna (ck-hero-right) çark `children` olarak geçilir. Mobilde dikey istif,
 * desktop'ta iki sütun. Tema rengi --theme-primary'den gelir.
 */
export default function Header({
  logoSrc = '',
  username = 'Misafir',
  spinCount = 0,
  onClaim,
  onHistory,
  claimDisabled = false,
  claimLoading = false,
  historyDisabled = false,
  children,
}) {
  const isNoRights = !spinCount || spinCount <= 0;
  // Default LONG logosu kaldırıldı — logo yalnızca admin Tasarım Editörü'nden yüklerse görünür.
  const logoUrl = logoSrc || '';

  return (
    <>
      {/* ─── Üst bar ─── */}
      <div className="ck-top">
        <div className="ck-top-left">
          {logoUrl && (
            <img src={logoUrl} alt="" className="ck-brand-logo" draggable="false" />
          )}
        </div>

        <div className="ck-counter" aria-label={`${spinCount} çevirme hakkı`}>
          <span className="ck-counter-label">Hak</span>
          <span className="ck-counter-num">{spinCount}</span>
        </div>

        <div className="ck-top-right">
          <button
            type="button"
            className="ck-icon-btn"
            onClick={onClaim}
            disabled={claimDisabled}
            aria-label="Hak Talep Et"
            title="Hak Talep Et"
          >
            {claimLoading ? (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                className="ck-icon-spin"
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="9" strokeDasharray="40 60" />
              </svg>
            ) : (
              <Icon name="tag" size={16} />
            )}
          </button>
          <button
            type="button"
            className="ck-icon-btn"
            onClick={onHistory}
            disabled={historyDisabled}
            aria-label="Geçmiş"
            title="Geçmiş"
          >
            <Icon name="history" size={16} />
          </button>
        </div>
      </div>

      {/* ─── Hero: sol metin · sağ çark ─── */}
      <div className="ck-hero">
        <div className="ck-hero-left">
          <div className="ck-eyebrow">
            {isNoRights ? 'Hakların tükendi' : `Hoşgeldiniz · ${username}`}
          </div>
          <h1 className="ck-h1">
            {isNoRights ? (
              <>
                Yenile<span className="ck-comma">,</span>
                <br />
                <span className="ck-h1-it">geri dön.</span>
              </>
            ) : (
              <>
                Çevir<span className="ck-comma">,</span>
                <br />
                <span className="ck-h1-it">kazan.</span>
              </>
            )}
          </h1>
          <p className="ck-sub">
            {isNoRights ? (
              <>
                Hakların tükendi, mola verme.
                <br />
                <em>Yeni hak talep et</em>, çevirmeye devam.
              </>
            ) : (
              <>
                Çarkı çevir, şansını hemen dene.
                <br />
                <em>Çıkan ödülü</em> anında kap.
              </>
            )}
          </p>
        </div>

        <div className="ck-hero-right">
          {children}
          {isNoRights ? (
            <button
              type="button"
              className="ck-hint ck-hint--action"
              onClick={onClaim}
              disabled={claimDisabled || claimLoading}
              aria-label="Yeni hak talep et"
            >
              {claimLoading ? 'Talep ediliyor…' : 'Yeni hak talep et'}
            </button>
          ) : (
            <div className="ck-hint">
              Çevirmek için çarka dokun
            </div>
          )}
        </div>
      </div>
    </>
  );
}
